import { has, get, curry } from 'lodash'

export const handleHours = (setFieldValue) => (hours) => {
  // only grab days with a set start and end time
  const picked = Object.keys(hours).reduce((days, day) => {
    if (hours[day].open === '' || hours[day].close === '') {
      return days
    }
    return { ...days, [day]: hours[day] }
  }, {})
  setFieldValue('hours', picked)
}

export const hasError = curry((errors, touched, field) => {
  return !!touched[field] && has(errors, field)
})

export const getError = curry((errors, touched, field) => {
  return touched[field] ? get(errors, field) : ''
})
